export enum ContentTypes {
  ApplicationJSON = 'application/json'
}
